import * as consts from '../constants';

import * as commonActions from './commonActions';
import emissionApi from '../api/emissionApi';

export function updateEmissionInvokeReducer(emissionState) {
    return { type: consts.ACTONS.UPDATE_CONTRAENTE, emissionState };
}

export function updateEmission(emissionState) {
    return function (dispatch, getState) {
        dispatch(updateEmissionInvokeReducer(emissionState));
    };
}

export function saveContractSuccess(contract) {
    return { type: consts.ACTONS.SAVE_CONTRACT_SUCCESS, contract };
}

export function createProposal(contract) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.createProposal(getState().authenticationState.token, contract).then(newContract => {
            dispatch(saveContractSuccess(newContract));
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function newDatiPagamentoForProposta(contract) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.newDatiPagamentoForProposta(getState().authenticationState.token, contract).then(newContract => {
            dispatch(commonActions.unlockScreen());
            return newContract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function newNoteAggiuntiveForProposta(contract) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.newNoteAggiuntiveForProposta(getState().authenticationState.token, contract).then(newContract => {
            dispatch(commonActions.unlockScreen());
            return newContract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveNoteNonStampate(contract) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.saveNoteNonStampate(getState().authenticationState.token, contract).then(newContract => {
            dispatch(commonActions.unlockScreen());
            return newContract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function deleteContract(contractId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.deleteContract(getState().authenticationState.token, contractId).then(() => {
            dispatch(loadContracts(getState().contractState));
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function cofermaPreventivo(contract) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.cofermaPreventivo(getState().authenticationState.token, contract).then(newContract => {
            dispatch(commonActions.unlockScreen());
            return newContract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function createAdesione(contract, targetDate) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.createAdesione(getState().authenticationState.token, contract, targetDate).then(updatedContract => {
            dispatch(commonActions.unlockScreen());
            return updatedContract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function payAccountPeriod(accountperiodId, targetDate) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.payAccountPeriod(getState().authenticationState.token, accountperiodId, targetDate).then(updatedContract => {
            dispatch(commonActions.unlockScreen());
            return updatedContract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function cancelAccountPeriod(accountperiodId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.cancelAccountPeriod(getState().authenticationState.token, accountperiodId).then(updatedContract => {
            dispatch(commonActions.unlockScreen());
            return updatedContract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function renewContract(contractId, targetDate, productId, instalmentMode) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.renewContract(getState().authenticationState.token, contractId, targetDate, productId, instalmentMode).then(updatedContract => {
            dispatch(commonActions.unlockScreen());
            return updatedContract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function cancelRenewContract(contractId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.cancelRenewContract(getState().authenticationState.token, contractId).then(updatedContract => {
            dispatch(commonActions.unlockScreen());
            return updatedContract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function closeContract(contractId, targetDate, closeAtTheEnd) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.closeContract(getState().authenticationState.token, contractId, targetDate, closeAtTheEnd).then(updatedContract => {
            dispatch(commonActions.unlockScreen());
            return updatedContract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function productsForRenew(contractId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.productsForRenew(getState().authenticationState.token, contractId).then((products) => {
            dispatch(commonActions.unlockScreen());
            return products;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadContractsSuccess(pagingModel) {
    return { type: consts.ACTONS.LOAD_CONTRACTS_SUCCESS, pagingModel };
}

export function loadContractsFailed() {
    return { type: consts.ACTONS.LOAD_CONTRACTS_FAILED };
}

export function loadContracts(pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.loadContracts(getState().authenticationState.token, pagingModel).then(res => {

            // Add custom properties
            res.agentId = pagingModel.agentId;
            res.clientName = pagingModel.clientName;
            res.contractStatus = pagingModel.contractStatus;
            res.expireDateDa = pagingModel.expireDateDa;
            res.expireDateA = pagingModel.expireDateA;
            res.inScadenza = pagingModel.inScadenza;
            res.networkId = pagingModel.networkId;
            res.productId = pagingModel.productId;
            res.proposalSequence = pagingModel.proposalSequence;
            res.sequence = pagingModel.sequence;
            res.startDateDa = pagingModel.startDateDa;
            res.startDateA = pagingModel.startDateA;

            dispatch(commonActions.unlockScreen());
            dispatch(loadContractsSuccess(res));
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadContractsFailed());
            throw (error);
        });
    };
}

export function contractsExport(pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.contractsExport(getState().authenticationState.token, pagingModel).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function stampaCertificatoAdesioneDipendente(id) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.stampaCertificatoAdesioneDipendente(getState().authenticationState.token, id).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function generaModuliPropostaDipendenti(printPrice, contractId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.generaModuliPropostaDipendenti(getState().authenticationState.token, printPrice, contractId).then((contract) => {
            dispatch(commonActions.unlockScreen());
            return contract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function generaCertificatiAdesioneDipendenti(contractId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.generaCertificatiAdesioneDipendenti(getState().authenticationState.token, contractId).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function inviaLetteraDiBenvutoDipendente(id) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.inviaLetteraDiBenvutoDipendente(getState().authenticationState.token, id).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function exportCSVContracts(pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.exportCSVContracts(getState().authenticationState.token, pagingModel).then(file => {
            dispatch(commonActions.unlockScreen());
            return file;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadContract(id) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.loadContract(getState().authenticationState.token, id).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadPGUsers(id, file, startDate) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.loadPGUsers(getState().authenticationState.token, id, file, startDate).then(contract => {
            dispatch(commonActions.unlockScreen());
            return contract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function filePersonaleLoad(id, file, documentPersonaleType) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.filePersonaleLoad(getState().authenticationState.token, id, file, documentPersonaleType).then(contract => {
            dispatch(commonActions.unlockScreen());
            return contract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function filePersonaleDelete(documentId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.filePersonaleDelete(getState().authenticationState.token, documentId).then(contract => {
            dispatch(commonActions.unlockScreen());
            return contract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function chiudiCoperturaMembro(contractMemberId, targetDate, familiare) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.chiudiCoperturaMembro(getState().authenticationState.token, contractMemberId, targetDate, familiare).then(contract => {
            dispatch(commonActions.unlockScreen());
            return contract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function addFamiliare(contractId, familiare) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.addFamiliare(getState().authenticationState.token, contractId, familiare).then(contract => {
            dispatch(commonActions.unlockScreen());
            return contract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function notificaProssimaScadenza(contractId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.notificaProssimaScadenza(getState().authenticationState.token, contractId).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function exportBeneficiari(contractId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.exportBeneficiari(getState().authenticationState.token, contractId).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function getCertificazioniIncassi(contractId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.getCertificazioniIncassi(getState().authenticationState.token, contractId).then((certificazioniIncassi) => {
            dispatch(commonActions.unlockScreen());
            return certificazioniIncassi;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}


// ********************************************************************************************************************************************
//                                          Piano Flex
// ********************************************************************************************************************************************

export function pianoFlexRenewContract(contractId, targetDate, instalmentMode, pianoFlex) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return emissionApi.pianoFlexRenewContract(getState().authenticationState.token, contractId, targetDate, instalmentMode, pianoFlex).then(updatedContract => {
            dispatch(commonActions.unlockScreen());
            return updatedContract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}